import useReveal from "../hooks/useReveal";
import Navbar from "../components/Navbar/Navbar";
import Newsletter from "../components/Newsletter/Newsletter";
import Footer from "../components/Footer/Footer";
import "./News.css";

const NEWS_ITEMS = [
  {
    id: 1,
    title: "New Game Launch Announcement",
    excerpt: "We're thrilled to announce the release of our most ambitious project to date. Join us for the grand launch event and be among the first to experience it.",
    date: "Latest Update",
    imageLeft: true,
    image: "/RG1.jpg",
  },
  {
    id: 2,
    title: "Mobile Gaming Trends 2025",
    excerpt: "Discover the latest trends in mobile gaming including AI-powered gameplay, cross-platform integration, and immersive AR experiences that are shaping the industry.",
    date: "Latest Update",
    imageLeft: false,
    image: "/RG2.jpg",
  },
  {
    id: 3,
    title: "Behind the Scenes: Game Development Process",
    excerpt: "Get an insider's look at how our team creates engaging games from concept to launch. Learn about our development methodology, tools, and best practices.",
    date: "Latest Update",
    imageLeft: true,
    image: "/x.png",
  },
  {
    id: 4,
    title: "Multiplayer Gaming Revolution",
    excerpt: "Explore how multiplayer gaming is transforming the entertainment landscape with real-time collaboration, competitive esports, and global player communities.",
    date: "Latest Update",
    imageLeft: false,
    image: "/RG4.jpg",
  },
  {
    id: 5,
    title: "Cross-Platform Gaming Solutions",
    excerpt: "Learn how we deliver seamless gaming experiences across iOS, Android, PC, and consoles. Discover the technical challenges and innovative solutions we implement.",
    date: "Latest Update",
    imageLeft: true,
    image: "/RG5.jpg",
  },
];

export default function News() {
  useReveal();

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="news-hero">
        <div className="news-hero-content reveal">
          <h1>Latest News & Updates</h1>
          <p>
            Stay informed about our latest game launches, industry insights,
            and company updates.
          </p>
          <a href="#news-list" className="btn-primary">Read latest updates →</a>
        </div>
      </section>

      {/* News List */}
      <section className="news-list-section section" id="news-list">
        <div className="container">
          {NEWS_ITEMS.map((item, i) => (
            <div
              key={item.id}
              className={`news-item reveal ${item.imageLeft ? "image-left" : "image-right"}`}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className="news-image">
                <img src={item.image || item.imageUrl} alt={item.title} className="news-image-img" loading="lazy" />
              </div>
              <div className="news-content">
                <span className="news-badge">{item.date}</span>
                <h3>{item.title}</h3>
                <p>{item.excerpt}</p>
                <a href={`#news-${item.id}`} className="news-link">
                  Read More →
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose iGamesTech */}
      <section className="why-choose-news section">
        <div className="container">
          <div className="reveal">
            <h2 className="section-title">Why Choose iGamesTech</h2>
            <p className="section-desc" style={{ maxWidth: "100%" }}>
              With years of experience in game and app development, our expert team delivers scalable,
              secure, and visually engaging solutions trusted by clients worldwide.
            </p>
          </div>
        </div>
      </section>

      <Newsletter />
      <Footer />
    </>
  );
}
